import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "invite-preview-notices"
}
const _hoisted_2 = {
  class: "bg-primary5 border border-primary/20 rounded-md px-4 py-3 text-sm text-textPrimary",
  "data-testid": "invite-what-happens"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-1" }, "O que acontece quando você confirmar", -1)
const _hoisted_4 = {
  key: 0,
  class: "list-disc pl-5 m-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "Ninguém é alocado agora.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, "As vagas continuam abertas em relatórios, contagens e exportações.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, "O médico recebe o convite no aplicativo e por e-mail.", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, "Os médicos recebem o convite no aplicativo e por e-mail.", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  "data-testid": "invite-deadline"
}
const _hoisted_13 = {
  key: 1,
  class: "list-disc pl-5 m-0"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, "O médico ocupa os plantões agora, sem aceite do Termo de Ciência.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, "O médico recebe um aviso no aplicativo.", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "text-sm bg-warning/20 border border-warning rounded-md px-4 py-2",
  "data-testid": "invite-started-notice"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Aviso:", -1)
const _hoisted_19 = {
  key: 1,
  class: "text-sm bg-warning/20 border border-warning rounded-md px-4 py-2",
  "data-testid": "pending-commitments-notice"
}
const _hoisted_20 = {
  key: 2,
  class: "text-sm bg-warning/20 border border-warning rounded-md px-4 py-2",
  "data-testid": "pending-commitments-failed"
}
const _hoisted_21 = {
  key: 3,
  class: "text-sm text-textPrimary",
  "data-testid": "invite-also-invited"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Também convidados:", -1)

import { computed } from 'vue'
import type {
  AllocationInvitePreview,
  PendingCommitment
} from '@/Network/Types/Responses/AllocationInviteResponses'
import {
  buildDoctorIssueNotices,
  buildStartedNotice,
  hasPendingCommitment,
  PENDING_CHECK_FAILED_NOTICE,
  pluralizeStations,
  splitInviteDeadline,
  type FillMode,
  type ReplacementChoice
} from './inviteWizard'

// Passo 3 do assistente de convite (acceptance-terms WEB-1): só apresentação; o modal carrega
// a prévia (convite) ou as pendências (alocação direta) e decide o envio.

export default /*#__PURE__*/_defineComponent({
  __name: 'InvitePreviewNotices',
  props: {
    fillMode: {},
    preview: {},
    inviteeNames: {},
    replacement: {},
    hasCurrentDoctor: { type: Boolean },
    pendingCommitments: {},
    pendingCheckFailed: { type: Boolean },
    doctorName: { type: Function },
    timezone: {},
    doctorCount: {}
  },
  setup(__props: any) {

const props = __props;



const eligibleCount = computed(() => props.preview?.eligibleStationIds.length ?? 0)
/** "o plantão" / "os 4 plantões". */
const eligibleStationsText = computed(() =>
  eligibleCount.value === 1 ? 'o plantão' : `os ${pluralizeStations(eligibleCount.value)}`
)
const deadline = computed(() =>
  props.preview ? splitInviteDeadline(props.preview, props.timezone) : null
)
// Os avisos por médico são do convite; na direta a prévia não existe (ou ficou de antes).
const issueNotices = computed(() =>
  props.fillMode === 'INVITE' && props.preview
    ? buildDoctorIssueNotices(props.preview, props.doctorName)
    : []
)

const startedNotice = computed(() =>
  props.fillMode === 'INVITE' && props.preview ? buildStartedNotice(props.preview) : null
)

const pendingNotice = computed(() => {
  if (props.fillMode !== 'DIRECT') return null
  const n = props.pendingCommitments.filter(hasPendingCommitment).length
  if (n === 0) return null
  return `${pluralizeStations(n)} ${n === 1 ? 'tem' : 'têm'} troca ou convite pendente. Ao confirmar, o pendente é cancelado e os envolvidos são avisados.`
})

const pendingFailedNotice = computed(() =>
  props.fillMode === 'DIRECT' && props.pendingCheckFailed ? PENDING_CHECK_FAILED_NOTICE : null
)

const replacementNotice = computed(() => {
  if (props.fillMode !== 'INVITE' || !props.hasCurrentDoctor) return null
  return props.replacement === 'NOW'
    ? 'O médico atual sai agora e recebe um aviso.'
    : 'O médico atual continua no plantão até o aceite e recebe um aviso se o convite cair.'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.fillMode === 'INVITE')
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            (_ctx.doctorCount === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  (eligibleCount.value > 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, "Ele fica com " + _toDisplayString(eligibleStationsText.value) + " quando aceitar.", 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9,
                  (eligibleCount.value > 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, " Quem aceitar primeiro fica com " + _toDisplayString(eligibleStationsText.value) + ". Os outros recebem um aviso. ", 1))
                    : _createCommentVNode("", true)
                ], 64)),
            (replacementNotice.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(replacementNotice.value), 1))
              : _createCommentVNode("", true),
            (deadline.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createTextVNode(" O convite vence em "),
                  _createElementVNode("strong", null, _toDisplayString(deadline.value.when), 1),
                  _createTextVNode(", " + _toDisplayString(deadline.value.reason) + ". ", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_13, _hoisted_16))
    ]),
    (startedNotice.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(startedNotice.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueNotices.value, (notice, index) => {
      return (_openBlock(), _createElementBlock("p", {
        key: index,
        class: "text-sm bg-warning/20 border border-warning rounded-md px-4 py-2",
        "data-testid": "invite-issue-notice"
      }, [
        _hoisted_18,
        _createTextVNode(" " + _toDisplayString(notice), 1)
      ]))
    }), 128)),
    (pendingNotice.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(pendingNotice.value), 1))
      : _createCommentVNode("", true),
    (pendingFailedNotice.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(pendingFailedNotice.value), 1))
      : _createCommentVNode("", true),
    (_ctx.fillMode === 'INVITE' && _ctx.inviteeNames.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
          _hoisted_22,
          _createTextVNode(" " + _toDisplayString(_ctx.inviteeNames.join(', ')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})